"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResizeDetectDivInternal = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-unused-vars */
const React = __importStar(require("react"));
const react_resize_detector_1 = require("react-resize-detector");
class ResizeDetectDivInternal extends React.Component {
    componentDidUpdate(prevProps) {
        const { width, height } = this.props;
        const widthChanged = width - prevProps.width;
        const heightChanged = height - prevProps.height;
        if (widthChanged && this.props.onWidthChange) {
            this.props.onWidthChange(width);
        }
        if (heightChanged && this.props.onHeightChange) {
            this.props.onHeightChange(height);
        }
        if ((heightChanged || widthChanged) && this.props.onResize) {
            this.props.onResize(width, height);
        }
    }
    render() {
        const _a = this.props, { width, height, 
        // eslint-disable-next-line react/prop-types
        children, onResize, onWidthChange, onHeightChange, targetRef } = _a, rest = __rest(_a, ["width", "height", "children", "onResize", "onWidthChange", "onHeightChange", "targetRef"]);
        return (0, jsx_runtime_1.jsx)("div", Object.assign({}, rest, { children: children }));
    }
}
exports.ResizeDetectDivInternal = ResizeDetectDivInternal;
exports.default = (0, react_resize_detector_1.withResizeDetector)(ResizeDetectDivInternal);
